import React from 'react'
import { Card, CardGroup, Col, Row } from 'react-bootstrap'

const AmazonBooks = () => {
  return (
    <>
        <Card className='no-border rounded-0 architectural-modeling container'>
            <Card className='text-center no-border rounded-0'>
                <Card.Body>
                    <Card.Title className='architectural-modeling-title'>Future of Retail</Card.Title>
                    <Card.Text className='architectural-modeling-text'>
                    As a demonstration of the future of ecommerce in an immersive virtual retail environment, we created a digital twin of a real bricks and motor bookstore. In VR users can entire the virtual store, pick up and peruse book selections populated from their online recommendations, put the book in their virtual shopping basket, to find them waiting in their online shopping cart when they return to the real world.
                    </Card.Text>
                    <CardGroup className='amazon-books-cardgroup'>
                        <Row>
                            <Col md={{span:6, offset:0}}>
                                <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                                    <Card.Img className='amazon-books-images' src={process.env.PUBLIC_URL + "assets/amazon-books/images/amazon_001.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Real Life<br /> Reference Photo</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={{span:6, offset:0}}>
                                <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                                    <Card.Img className='amazon-books-images' src={process.env.PUBLIC_URL + "assets/amazon-books/images/amazon_001_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Virtual Image Rendered <br /> From 3D Models</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CardGroup>

                    <CardGroup className='amazon-books-cardgroup mt-5'>
                        <Row>
                            <Col md={{span:6, offset:0}}>
                                <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                                    <Card.Img className='amazon-books-image-second' src={process.env.PUBLIC_URL + "assets/amazon-books/images/amazon_002.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Real Life<br /> Reference Photo</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={{span:6, offset:0}}>
                                <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                                    <Card.Img className='amazon-books-images' src={process.env.PUBLIC_URL + "assets/amazon-books/images/amazon_002_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Virtual Image Rendered <br /> From 3D Models</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CardGroup>


                    {/* <CardGroup className='amazon-books-cardgroup mt-5'>
                        <Row>
                            <Col md={{span:6, offset:0}}>
                                <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                                    <Card.Img className='amazon-books-image-third' src={process.env.PUBLIC_URL + "assets/amazon-books/images/amazon_003.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Real Life Photograph Reference Images</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={{span:6, offset:0}}>
                                <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                                    <Card.Img className='amazon-books-images' src={process.env.PUBLIC_URL + "assets/amazon-books/images/amazon_003_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Images Rendered From 3D Model</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CardGroup> */}
                </Card.Body>
            </Card>
        </Card>
      
    </>
  )
}

export default AmazonBooks
